import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import CouponUseList from './CouponUseList';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateAdapter from '@mui/lab/AdapterMoment';
import DatePicker from '@mui/lab/DatePicker';

export default function CouponCreate(props) {
  const {
    register,
    handleSubmit,
    reset,
    setError,
    formState: { errors }
  } = useForm({
    defaultValues: {
      quantity: 0
    }
  });

  const { open, handleClose, id } = props;
  const [datas, setDatas] = useState({});
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const onSubmit = async (data) => {
    if (data.quantity == 0) {
      setError('quantity', { type: 'nonZero', message: '0개는 생성 할수 없습니다.' });
      return;
    }

    if (endDate < startDate) {
      setError('endDate', { type: 'nonPast', message: '종료일이 시작일보다 빠를수 없습니다.' });
      return;
    }

    let params = {};
    params.quantity = data.quantity;
    params.startDate = data.startDate;
    params.endDate = data.endDate;

    await axios
      .post(`/api/coupon/${id}`, params)
      .then((response) => {
        alert(response.data.message);
        init();
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  function leftPad(value) {
    if (value >= 10) {
      return value;
    }
    return `0${value}`;
  }

  function toStringByFormatting(source, delimiter = '-') {
    const year = source.getFullYear();
    const month = leftPad(source.getMonth() + 1);
    const day = leftPad(source.getDate());
    return [year, month, day].join(delimiter);
  }

  const init = async () => {
    const response = await axios.get(`/api/company/${id}`);
    if (response.data) {
      setDatas(response.data);
      const now = toStringByFormatting(new Date());
      reset({ quantity: 0, startDate: now, endDate: now });
    }
  };

  useEffect(async () => {
    if (open) {
      await init();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title">
      <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1, minWidth: 500 }}>
        <DialogTitle id="draggable-dialog-title">사용권 생성</DialogTitle>
        <DialogContent dividers>
          <Box>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableRow>
                  <TableCell>회사</TableCell>
                  <TableCell>
                    {datas.companyName} ({datas.companyNo})
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>규모</TableCell>
                  <TableCell>{datas.scaleNm}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>현재 사용권</TableCell>
                  <TableCell>{datas.residualQuantity}</TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
          <Box sx={{ mt: 3 }}>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableRow>
                  <TableCell>사용권 생성</TableCell>
                  <TableCell>
                    <TextField
                      id="quantity"
                      type="number"
                      variant="outlined"
                      size="small"
                      autoFocus
                      error={!!errors.quantity}
                      helperText={errors.quantity && errors.quantity.message}
                      {...register('quantity', {
                        required: '사용권 수량을 입력해주세요.'
                      })}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>사용 시작일</TableCell>
                  <TableCell>
                    <LocalizationProvider dateAdapter={DateAdapter}>
                      <DatePicker
                        inputFormat={'yyyy-MM-DD'}
                        value={startDate}
                        onChange={(newValue) => {
                          setStartDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            sx={{ width: '70%' }}
                            error={!!errors.startDate}
                            helperText={errors.startDate && errors.startDate.message}
                            {...register('startDate', {
                              required: '시작일을 입력해주세요.'
                            })}
                          />
                        )}
                        disableMaskedInput={true}
                        disablePast={true}
                      />
                    </LocalizationProvider>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>사용 종료일</TableCell>
                  <TableCell>
                    <LocalizationProvider dateAdapter={DateAdapter}>
                      <DatePicker
                        inputFormat={'yyyy-MM-DD'}
                        value={endDate}
                        onChange={(newValue) => {
                          if (newValue < startDate) {
                            setError('endDate', { type: 'nonPast', message: '종료일이 시작일보다 빠를수 없습니다.' });
                            return;
                          }
                          setEndDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            sx={{ width: '70%' }}
                            error={!!errors.endDate}
                            helperText={errors.endDate && errors.endDate.message}
                            {...register('endDate', {
                              required: '종료일을 입력해주세요.'
                            })}
                          />
                        )}
                        disableMaskedInput={true}
                        disablePast={true}
                      />
                    </LocalizationProvider>
                  </TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
          {datas.residualQuantity != 0 && (
            <Box>
              <CouponUseList companyId={id} pDatas={datas} />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button type="submit" variant="contained" color="primary">
            생성
          </Button>
          <Button variant="outlined" color="success" onClick={handleClose}>
            닫기
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
